class ExternalLinks {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._links = document.links
    }
    onInit () {
        for (let i = 0; i < this._links.length; i++) {
            if (this._links[i].hostname !== window.location.hostname) {
                this._links[i].target = '_blank'
                this._links[i].rel = 'noreferrer noopener'
            }
        }
    }
}

export default ExternalLinks



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ExternalLinks.js